import axios from '@/axios';
import {notification} from "ant-design-vue";

const state = {
    collectionSingle: undefined,
    error: undefined,
    loading: false,
    users: [],
    successData: undefined,
    collection: [],
    groups: []
};
const actions = {

    async submitCollection({commit}, payload) {
        try {
            commit('LOADING', true);
            if (payload.id) {
                await axios({
                    method: 'put',
                    url: 'admin/collection/' + payload.id,
                    data: {id: payload.id, data: payload.data}
                });
            } else {
                await axios({
                    method: 'post',
                    url: 'admin/collection',
                    data: {data: payload}
                });
            }
        } catch (e) {
            console.log(e);
            throw e;
        } finally {
            commit('LOADING', false);
        }

    },
    async collectionId({commit}, id) {
        try {
            commit('LOADING', true);
            let res = await axios.get('admin/collection/' + id);
            commit('COLLECTION_ID', res.data);
        } catch (e) {
            commit('ERROR', e);
            throw e;
        } finally {
            commit('LOADING', false);
        }
    },


};
const mutations = {
    LOADING(state, payload) {
        state.loading = payload;
    },
    SET_ROW_ATTR(state, payload) {
        if (!payload.id) {
            state.collectionSingle.groups.push(payload);
        } else {
            const ind = state.collectionSingle.groups.indexOf(state.collectionSingle.groups.find((item) => item.id == payload.id));
            if (ind > -1) {
                state.collectionSingle.groups[ind] = Object.assign({}, payload)
            }
        }
    },
    DELETE_ROW(state, payload) {
        state.collectionSingle.groups.splice(payload,1)
    },
    COLLECTION_ID(state, payload) {
        state.collectionSingle = payload;
    },
    SUCCESS_DATA(state, payload) {
        state.successData = payload;
    },
    UPDATE_COLLECTION(state, payload) {
        state.collection = state.collection.map(collection => {
            if (collection.id === payload.id) {
                return Object.assign({}, collection, payload.data);
            }
            return collection;
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
